/**
 * Returns the array index of a correlation.
 *
 * @param {Values} correlations
 * @param {Correlation} correlation
 */
export function getCorrelationIndex(correlations, correlation) {
    return correlations.findIndex((_correlation) => _correlation.id === correlation.id);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q29ycmVsYXRpb25JbmRleC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvZ2VuZXJhbC9nZXRDb3JyZWxhdGlvbkluZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLG1CQUFtQixDQUNqQyxZQUFvQixFQUNwQixXQUF3QjtJQUV4QixPQUFPLFlBQVksQ0FBQyxTQUFTLENBQzNCLENBQUMsWUFBWSxFQUFFLEVBQUUsQ0FBQyxZQUFZLENBQUMsRUFBRSxLQUFLLFdBQVcsQ0FBQyxFQUFFLENBQ3JELENBQUM7QUFDSixDQUFDIn0=